module.exports = __webpack_public_path__ + "img/slider_6.22755efc.jpg";